// Production environment configuration
// Used for production builds deployed to Cloud Run
export const environment = {
  production: true,
  apiUrl: 'https://seoms-server-5k7jc2butq-uc.a.run.app/api/v1',
};
